import { TFunction } from 'react-i18next';
import { AdminRoles, AdminStatus } from '../../../models/admins.model';

export const getRoleOptions = (t: TFunction) =>
  Object.values(AdminRoles).map((value) => ({
    value,
    label: t(`admin_roles_${value.toLowerCase()}`),
  }));

export const getStatusOptions = (t: TFunction) =>
  Object.values(AdminStatus).map((value) => ({
    value,
    label: t(`admin_statuses_${value.toLowerCase()}`),
  }));
